// extracted by mini-css-extract-plugin
export default {"outer":"Error-module--outer--4fc9b","error":"Error-module--error--59954"};